const thousandSeperators = n =>
  n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')

const formatMileage = mileage =>
  mileage ? `${thousandSeperators(mileage)} Miles` : null

module.exports = formatMileage
